export const brevisBatchDistributorAbi = [
  {
    inputs: [
      { internalType: "address", name: "earner", type: "address" },
      { internalType: "address[]", name: "campaignAddrs", type: "address[]" },
    ],
    name: "claimAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "earner", type: "address" },
      { internalType: "address[]", name: "campaignAddrs", type: "address[]" },
      {
        components: [
          { internalType: "address", name: "campaignAddr", type: "address" },
          {
            internalType: "uint256[]",
            name: "cumulativeAmounts",
            type: "uint256[]",
          },
          { internalType: "uint64", name: "epoch", type: "uint64" },
          { internalType: "bytes32[]", name: "proof", type: "bytes32[]" },
        ],
        internalType: "struct ClaimAll.CampaignReward[]",
        name: "campaignRewards",
        type: "tuple[]",
      },
    ],
    name: "claimAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "earner", type: "address" },
      {
        components: [
          { internalType: "address", name: "campaignAddr", type: "address" },
          {
            internalType: "uint256[]",
            name: "cumulativeAmounts",
            type: "uint256[]",
          },
          { internalType: "uint64", name: "epoch", type: "uint64" },
          { internalType: "bytes32[]", name: "proof", type: "bytes32[]" },
        ],
        internalType: "struct ClaimAll.CampaignReward[]",
        name: "campaignRewards",
        type: "tuple[]",
      },
    ],
    name: "claimAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const
